import React from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck, Star, Zap, Lock, AlertTriangle, ArrowRight, Sparkles, Smartphone, Brain, Shield, Flame } from 'lucide-react';
import { Button } from './ui/Button';
export function CTASection() {
  return <section id="offer" className="py-20 bg-white" data-id="element-71">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-72">
        <div className="max-w-4xl mx-auto bg-[#1E1B4B] rounded-3xl overflow-hidden shadow-2xl text-white" data-id="element-73">
          <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-74">
            <div className="p-8 md:p-12 flex flex-col justify-center" data-id="element-75">
              <h2 className="text-3xl font-bold mb-4 text-white" data-id="element-76">
                Start Your{' '}
                <span className="relative inline-block" data-id="element-77">
                  <span className="relative z-10" data-id="element-78">7-Day Reset</span>
                  <span className="absolute bottom-1 left-0 w-full h-3 bg-[#818CF8]/40 -z-0 rounded-sm" data-id="element-79"></span>
                </span>{' '}
                Now
              </h2>
              <p className="text-[#FCA5A5] text-sm font-semibold mb-2 flex items-center gap-1.5" data-id="element-80">
                <AlertTriangle className="w-4 h-4" data-id="element-81" /> Waiting doesn't reduce
                anxiety.{' '}
                <span className="underline decoration-2 decoration-[#FDE68A]" data-id="element-82">
                  Training does.
                </span>
              </p>
              <p className="text-[#C7D2FE] mb-6" data-id="element-83">
                Download the guide. Do{' '}
                <span className="text-white font-semibold" data-id="element-84">
                  one action per day.
                </span>{' '}
                <span className="bg-[#818CF8]/30 px-1 rounded text-white font-semibold" data-id="element-85">
                  Lower your anxiety baseline
                </span>{' '}
                this week.
              </p>

              <div className="bg-white/5 border border-white/10 rounded-lg p-4 mb-6" data-id="element-86">
                <p className="text-white/90 text-sm font-medium mb-2 flex items-center gap-1.5" data-id="element-87">
                  <Sparkles className="w-4 h-4" data-id="element-88" /> Imagine waking up on Day 8:
                </p>
                <ul className="space-y-1 text-sm text-[#C7D2FE]" data-id="element-89">
                  <li className="flex items-center gap-1.5" data-id="element-90">
                    <ArrowRight className="w-3 h-3 text-[#A5B4FC]" data-id="element-91" /> Your chest
                    feels lighter
                  </li>
                  <li className="flex items-center gap-1.5" data-id="element-92">
                    <ArrowRight className="w-3 h-3 text-[#A5B4FC]" data-id="element-93" /> Your
                    thoughts don't spiral
                  </li>
                  <li className="flex items-center gap-1.5" data-id="element-94">
                    <ArrowRight className="w-3 h-3 text-[#A5B4FC]" data-id="element-95" /> You slept
                    through the night
                  </li>
                  <li className="flex items-center gap-1.5" data-id="element-96">
                    <ArrowRight className="w-3 h-3 text-[#A5B4FC]" data-id="element-97" /> You feel{' '}
                    <span className="text-[#FDE68A] font-semibold" data-id="element-98">
                      in control
                    </span>
                  </li>
                </ul>
              </div>

              <ul className="space-y-4 mb-8" data-id="element-99">
                {[{
                icon: Zap,
                text: 'Instant digital access'
              }, {
                icon: Smartphone,
                text: "Works even if you're busy"
              }, {
                icon: Brain,
                text: 'No "perfect mindset" required'
              }, {
                icon: Shield,
                text: '30-day money-back guarantee'
              }].map((item, i) => <li key={i} className="flex items-center" data-id="element-100">
                    <div className="bg-[#4338CA] rounded-full p-1 mr-3" data-id="element-101">
                      <item.icon className="w-3 h-3 text-white" data-id="element-102" />
                    </div>
                    <span className="font-medium text-[#E0E7FF]" data-id="element-103">
                      {item.text}
                    </span>
                  </li>)}
              </ul>

              <div className="flex items-center gap-2 text-xs text-[#A5B4FC] mt-auto" data-id="element-104">
                <Lock className="w-3 h-3" data-id="element-105" />
                Secure 256-bit SSL Encryption
              </div>
            </div>

            <div className="bg-[#FAFAFF] p-8 md:p-12 flex flex-col items-center justify-center text-center relative overflow-hidden" data-id="element-106">
              <div className="relative z-10 w-full max-w-xs bg-white rounded-2xl p-6 shadow-xl border border-[#E0E7FF]" data-id="element-107">
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#FDE68A] text-[#92400E] text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider shadow-sm flex items-center gap-1" data-id="element-108">
                  <Flame className="w-3 h-3" data-id="element-109" /> 92% Off — Limited Time
                </div>
                <h3 className="text-xl font-bold text-[#1E1B4B] mt-3 mb-1" data-id="element-110">
                  7 Signals Reset™
                </h3>
                <p className="text-sm text-[#78716C] mb-1" data-id="element-111">
                  Complete Digital System
                </p>
                <p className="text-xs text-[#4338CA] font-medium mb-4" data-id="element-112">
                  Main Guide + 4 Bonus Guides
                </p>
                <div className="flex items-center justify-center gap-2 mb-1" data-id="element-113">
                  <span className="text-lg text-[#A8A29E] line-through" data-id="element-114">
                    $126.88
                  </span>
                  <span className="text-4xl font-bold text-[#1E1B4B]" data-id="element-115">
                    $9.97
                  </span>
                </div>
                <p className="text-xs text-[#78716C] mb-6" data-id="element-116">
                  One-time payment · Lifetime access
                </p>
                <Button fullWidth className="mb-3 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all text-lg py-4" onClick={() => window.open('https://bullygooddogs.com/cart/add?id=51339283890493&quantity=1', '_blank')} data-id="element-117">
                  Download Now — $9.97
                </Button>
                <p className="text-[10px] text-[#78716C] leading-tight mb-2 flex items-center justify-center gap-1" data-id="element-118">
                  <ShieldCheck className="w-3 h-3" data-id="element-119" /> 30-Day Money Back
                  Guarantee. No questions asked.
                </p>
                <p className="text-[10px] text-[#A8A29E] leading-tight" data-id="element-120">
                  You don't need a perfect life to feel calmer. You need a
                  nervous system that remembers safety.
                </p>
              </div>

              <div className="mt-8 flex items-center justify-center gap-6" data-id="element-121">
                <div className="flex flex-col items-center" data-id="element-122">
                  <ShieldCheck className="w-6 h-6 text-[#4338CA] mb-1" data-id="element-123" />
                  <span className="text-xs text-[#78716C] font-medium" data-id="element-124">
                    Secure
                  </span>
                </div>
                <div className="flex flex-col items-center" data-id="element-125">
                  <Zap className="w-6 h-6 text-[#4338CA] mb-1" data-id="element-126" />
                  <span className="text-xs text-[#78716C] font-medium" data-id="element-127">
                    Instant
                  </span>
                </div>
                <div className="flex flex-col items-center" data-id="element-128">
                  <div className="flex" data-id="element-129">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 text-[#818CF8] fill-current" data-id="element-130" />)}
                  </div>
                  <span className="text-xs text-[#78716C] font-medium mt-1" data-id="element-131">
                    Top Rated
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}